import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Изготавливаются из 100% супер чесаного хлопка высшего качества. Короткий рукав. Круглая горловина, обработанная лайкрой, устойчива к растяжениям. Усиленные плечевые швы. Не теряет яркости после многочисленных стирок. Плотность материала – 155гр/м<sup>2</sup>.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}${maintenance}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`kids_tee`],
      sizeInfo: `kids_tee`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
